import { get } from 'lodash-es';
import createCachedSelector from 're-reselect';
import { emptyObject, emptyArray } from 'ui-components/default-props/empty';

const selectCustomers = (state) => get(state, 'customers', emptyObject);

export const selectCustomersByIds = createCachedSelector(
  selectCustomers,
  (_, props) => JSON.stringify(props.customerIds),
  (customers, customerIdsJSON) => {
    const customerIds = JSON.parse(customerIdsJSON);

    if (customerIds.length === 0) {
      return emptyArray;
    }

    return customerIds.map((customerId) => customers[customerId]);
  },
)((_, props) => JSON.stringify(props.customerIds));
